"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFormat = void 0;
var striptags_1 = __importDefault(require("striptags"));
function removeFormat(content, replacement) {
    return (0, striptags_1.default)(content, undefined, replacement);
}
exports.removeFormat = removeFormat;
